import React from 'react';
import { Provider } from 'mobx-react';
import { MobxIntlProvider, LocaleStore } from 'mobx-react-intl';
import { addLocaleData } from 'react-intl';

// Import translations
import enJson from './translations/deliver.media_Console_English.json';
import deJson from './translations/deliver.media_Console_German.json';
import deCHJson from './translations/deliver.media_Console_German_CH.json';
import frJson from './translations/deliver.media_Console_French.json';

// Flatten translations
import flatten from 'flat';

const en = flatten(enJson);
const de = flatten(deJson);
const deCH = flatten(deCHJson);
const fr = flatten(frJson);

import enLocale from 'react-intl/locale-data/en';
import deLocale from 'react-intl/locale-data/de';
import frLocale from 'react-intl/locale-data/fr';

addLocaleData([...frLocale, ...deLocale, ...enLocale]);

// Internationalization
const localeStore = new LocaleStore('en', {
    en, de, 'de-CH': deCH, fr,
});


import { render } from 'react-dom';
import App from './Components/App';

import authStore from './State/Auth';
import userStore from './State/UserStore';
import AssetStore from './Components/assets/model/AssetStore';

const stores = {
    // Key can be whatever you want
    // routing: routingStore,
    auth: authStore,
    users: userStore,

    assets: new AssetStore(authStore),

    locale: localeStore,
    // ...other stores
};

// To switch back to AP mode only, simply replace App with Main

render(
    <Provider {...stores}>
        <MobxIntlProvider>
            <App />
        </MobxIntlProvider>
    </Provider>,
    document.getElementById('app'),
);
